import React, { useMemo, useState } from 'react';

// Simple responsive horizontal bar chart
// Props:
// - data: Array<{ label: string, value: number, color?: string }>
// - height?: number (default 220)
export default function SimpleHorizontalBarChart({ data = [], height = 220 }) {
  const [hoverIndex, setHoverIndex] = useState(null);

  const bars = useMemo(() => {
    const max = Math.max(1, ...data.map(d => Number(d.value) || 0));
    return data.map(d => ({ ...d, value: Number(d.value) || 0, max }));
  }, [data]);

  const fmt = (n) => new Intl.NumberFormat('es-CL').format(n || 0);
  const labelWidth = 100;
  const barHeight = 24;
  const gap = 12;
  const width = 360;
  const chartWidth = width - labelWidth - 40;
  const neededHeight = Math.max(height, bars.length * (barHeight + gap) + 24);

  return (
    <div className="w-full overflow-x-auto">
      <svg width={width} height={neededHeight} role="img" aria-label="Gráfico de barras horizontal">
        {bars.map((d, i) => {
          const y = 12 + i * (barHeight + gap);
          const w = (d.value / d.max) * chartWidth;
          const isHover = hoverIndex === i;
          return (
            <g key={i} onMouseEnter={() => setHoverIndex(i)} onMouseLeave={() => setHoverIndex(null)}>
              <text x={labelWidth - 8} y={y + barHeight / 2 + 4} textAnchor="end" fontSize="11" fill="#374151" className="truncate">
                {String(d.label || '').slice(0, 18)}
              </text>
              <rect
                x={labelWidth}
                y={y}
                width={Math.max(4, w)}
                height={barHeight}
                rx={6}
                fill={d.color || '#a855f7'}
                opacity={isHover ? 0.95 : 0.85}
              />
              <text x={labelWidth + w + 6} y={y + barHeight / 2 + 4} fontSize="11" fill="#374151">
                {fmt(d.value)}
              </text>
              {isHover && w > 40 && (
                <text x={labelWidth + w / 2} y={y - 6} textAnchor="middle" fontSize="10" fill="#111827">
                  {d.label}: {fmt(d.value)}
                </text>
              )}
            </g>
          );
        })}
      </svg>
    </div>
  );
}
